<template>
  <div v-if="isNotAdminSection" class="text-h5">{{ $t('AGENT_CATEGORY') }} {{ getCommercial }}</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'HeaderUser',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    getCommercial() {
      return this[GET_OFFER_ITEM]('commercial')
    },
    isNotAdminSection() {
      return this.$route.path !== '/admin'
    },
  },
}
</script>
